import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "card mb-5 mb-xl-8" }
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_15 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_16 = {
  key: 0,
  style: {"height":"1500px"}
}
const _hoisted_17 = { colspan: "12" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { colspan: "12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "--", -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]

import { ref, onMounted, inject } from "vue";
import TimeShow from "@/components/TimeShow.vue";
import { useI18n } from "vue-i18n";
import RebateService from "../services/RebateService";
import SchemaDetail from "../components/SchemaDetail.vue";
import SchemaUsers from "../components/SchemaUsers.vue";
import AddSchama from "../components/AddNewRebateSchema.vue";
import TableFooter from "@/components/TableFooter.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { RebateSchemaType } from "@/core/types/RebateSchemaType";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Search } from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RebateScheme',
  setup(__props) {

const { t } = useI18n();
const isLoading = ref(true);
const deleteIndex = ref(-1);
const SchemaDetailRef = ref<any>(null);
const SchemaUsersRef = ref<any>(null);
const AddSchamaRef = ref<any>(null);
const rebateRules = ref(Array<any>());
const currentTab = ref(RebateSchemaType.Rebate);
const openConfirmBox = inject<any>(InjectKeys.OPEN_CONFIRM_MODAL);

const criteria = ref({
  page: 1,
  size: 10,
  numPages: 1,
  total: 0,
  keyword: "",
  type: RebateSchemaType.Rebate,
  sortField: "updatedOn",
  sortFlag: true,
});

const reset = () => {
  criteria.value.keyword = "";
  fetchData(1);
};

onMounted(async () => {
  fetchData(1);
});

const refresh = () => {
  fetchData(1);
};

const changeTab = async (_tab) => {
  currentTab.value = _tab;
  criteria.value.type = _tab;
  await fetchData(1);
};

const getSchemaUsers = async (_id: number) => {
  SchemaUsersRef.value.show(_id);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;

  try {
    var res;
    if (criteria.value.type == RebateSchemaType.Rebate) {
      res = await RebateService.queryRebateSchemas(criteria.value);
    } else if (criteria.value.type == RebateSchemaType.Base) {
      res = await RebateService.queryBaseRebateSchemas(criteria.value);
    } else {
      res = await RebateService.queryRebateSchemaBundle(criteria.value);
    }

    criteria.value = res.criteria;
    criteria.value.type = currentTab.value;
    rebateRules.value = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const showAddNewModal = (_schemaType: number) => {
  AddSchamaRef.value.show(_schemaType);
};

const pageChange = (_page: number) => {
  fetchData(_page);
};

const openConfirmPanel = (_id: number) => {
  const _handler = {
    [RebateSchemaType.Rebate]: () => RebateService.deleteRebateSchema(_id),
    [RebateSchemaType.Base]: () => RebateService.deleteBaseSchemaList(_id),
    [RebateSchemaType.Rate]: () => RebateService.deleteRebateSchemaBundle(_id),
    [RebateSchemaType.Pips]: () => RebateService.deleteRebateSchemaBundle(_id),
    [RebateSchemaType.Commission]: () =>
      RebateService.deleteRebateSchemaBundle(_id),
  }[currentTab.value];
  if (!_handler) {
    MsgPrompt.error(t("tip.fail"));
    return;
  }
  openConfirmBox(async () => {
    try {
      await _handler()
        .then(() => MsgPrompt.success())
        .then(() => {
          fetchData(criteria.value.page);
        });
    } catch (error) {
      MsgPrompt.error("有人正在使用该方案，或聯繫 IT 人員");
    }
  });
};

const showSchemaDetail = (_id: number) => {
  SchemaDetailRef.value.show(_id, currentTab.value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", [
              { active: currentTab.value === _unref(RebateSchemaType).Rebate },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(_unref(RebateSchemaType).Rebate)))
          }, "Rebate Schema", 2)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", [
              { active: currentTab.value === _unref(RebateSchemaType).Base },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(_unref(RebateSchemaType).Base)))
          }, "Base Schema", 2)
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", [
              { active: currentTab.value === _unref(RebateSchemaType).Rate },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(_unref(RebateSchemaType).Rate)))
          }, "Rate Schema", 2)
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", [
              { active: currentTab.value === _unref(RebateSchemaType).Pips },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(_unref(RebateSchemaType).Pips)))
          }, "Pips Schema", 2)
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-4", [
              { active: currentTab.value === _unref(RebateSchemaType).Commission },
              { 'disabled opacity-50 pe-none': isLoading.value },
            ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(_unref(RebateSchemaType).Commission)))
          }, "Commission Schema", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "btn btn-light btn-success btn-sm me-3",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showAddNewModal(currentTab.value)))
        }, _toDisplayString([
              "New Base Schema",
              "New Rate Schema",
              "New Pips Schema",
              "New Commission Schema",
              "New Rebate Schema",
            ][currentTab.value]), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.keyword,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((criteria.value.keyword) = $event)),
            placeholder: "Search by Name",
            onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1)))
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            class: "ms-5",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode("Reset")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_15, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.id")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdBy")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.note")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_17, [
                    _createVNode(ScaleLoader)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && rebateRules.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t("tip.nodata")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && rebateRules.value.length != 0)
            ? (_openBlock(), _createBlock(_TransitionGroup, {
                key: 2,
                tag: "tbody",
                name: "table-delete-fade",
                class: "table-delete-fade-container text-gray-600 fw-semibold"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateRules.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item,
                      class: _normalizeClass({ 'table-delete-fade-active': index === deleteIndex.value })
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.createdByPartyName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.updatedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _hoisted_20,
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-light btn-success btn-sm me-3",
                          onClick: ($event: any) => (showSchemaDetail(item.id))
                        }, _toDisplayString(_ctx.$t("title.details")), 9, _hoisted_21),
                        (currentTab.value == _unref(RebateSchemaType).Rebate)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-light btn-info btn-sm me-3",
                              onClick: ($event: any) => (getSchemaUsers(item.id))
                            }, _toDisplayString(_ctx.$t("title.users")), 9, _hoisted_22))
                          : _createCommentVNode("", true),
                        (
                    currentTab.value !== _unref(RebateSchemaType).Rebate &&
                    currentTab.value !== _unref(RebateSchemaType).Base
                  )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-light btn-danger btn-sm",
                              onClick: ($event: any) => (openConfirmPanel(item.id))
                            }, _toDisplayString(_ctx.$t("action.delete")), 9, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ]),
      _createVNode(SchemaDetail, {
        ref_key: "SchemaDetailRef",
        ref: SchemaDetailRef,
        onRefresh: refresh
      }, null, 512),
      _createVNode(SchemaUsers, {
        ref_key: "SchemaUsersRef",
        ref: SchemaUsersRef
      }, null, 512),
      _createVNode(AddSchama, {
        ref_key: "AddSchamaRef",
        ref: AddSchamaRef,
        onRefresh: refresh
      }, null, 512)
    ])
  ]))
}
}

})